import * as assert from 'assert';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import '../../assets/styles/Dashboard.css';
import * as Style from '../../assets/styles/Pages/Home';
import { ApplicationStore } from '../../data_layer/stores/ApplicationStore';
import { BasalMetabolicRateFull } from '../components/fullSummaryPanels/BasalMetabolicRateFull';
import { BodyFatFull } from '../components/fullSummaryPanels/BodyFatFull';
import { SkeletalMuscleMassFull } from '../components/fullSummaryPanels/FatFreeMassFull';
import { TotalBodyWaterFull } from '../components/fullSummaryPanels/TotalBodyWaterFull';
import { VisceralFatLevelFull } from '../components/fullSummaryPanels/VisceralFatLevelFull';
import { Page } from './Page';

interface RouteParams {
    category: FullSummaryCategories;
    id?: string; // numeric string
}

interface Props extends RouteComponentProps<RouteParams> {
    currentCategory: string;
    store: ApplicationStore;
}

interface State {}

export enum FullSummaryCategories {
    VisceralFat = 'visceral-fat-level',
    BodyFat = 'body-fat',
    BasalMetabolic = 'basal-metabolic-rate',
    SkeletalMuscleMass = 'skeletal-muscle-mass',
    BodyWater = 'total-body-water',
}

export const FullSummaryLinks = [
    {
        route: FullSummaryCategories.VisceralFat,
        label: 'Visceral Fat Level',
    },
    {
        route: FullSummaryCategories.BodyFat,
        label: 'Body Fat',
    },
    {
        route: FullSummaryCategories.BasalMetabolic,
        label: 'Basal Metabolic Rate',
    },
    {
        route: FullSummaryCategories.SkeletalMuscleMass,
        label: 'Skeletal Muscle Mass',
    },
    {
        route: FullSummaryCategories.BodyWater,
        label: 'Total Body Water',
    },
];

@inject('store')
@observer
export class FullSummary extends Page<Props, State> {
    private scanId?: number;
    public constructor(props: Props) {
        super(props);
        if (this.props.match.params.id) {
            this.scanId = parseInt(this.props.match.params.id);
        }
        this.setActivePoint();
    }

    public componentWillReceiveProps(nextProps: Props): void {
        if (nextProps.match.params.id) {
            this.scanId = parseInt(nextProps.match.params.id);
            this.setActivePoint();
        } else {
            this.scanId = undefined;
            this.props.store.scanStore.clearActiveScan();
        }
    }

    private setActivePoint(): void {
        if (undefined != this.scanId) {
            this.props.store.scanStore.setActiveScan(this.scanId);
        } else {
            this.props.store.scanStore.clearActiveScan();
        }
    }

    private renderPanel(): React.ReactNode {
        switch (this.props.match.params.category) {
            case FullSummaryCategories.VisceralFat:
                return <VisceralFatLevelFull scanStore={this.props.store.scanStore} scan_id={this.scanId} />;
            case FullSummaryCategories.BodyFat:
                return <BodyFatFull scanStore={this.props.store.scanStore} scan_id={this.scanId} />;
            case FullSummaryCategories.BasalMetabolic:
                return <BasalMetabolicRateFull scanStore={this.props.store.scanStore} scan_id={this.scanId} />;
            case FullSummaryCategories.SkeletalMuscleMass:
                return <SkeletalMuscleMassFull scanStore={this.props.store.scanStore} scan_id={this.scanId} />;
            case FullSummaryCategories.BodyWater:
                return <TotalBodyWaterFull scanStore={this.props.store.scanStore} scan_id={this.scanId} />;
            default:
                assert(false, 'FullSummary#renderPanel - unknown category');
                return null;
        }
    }

    public renderPage(): React.ReactNode {
        return (
            <div style={Style.Home}>
                <div style={Style.PanelContainer}>{this.renderPanel()}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/pages/FullSummary.tsx